import React from 'react';
import ListFlowBaseDescription from '~/components/ListFlow/Descriptions/ListFlowBaseDescription';

interface Props {}

const ListFlowInfoDescription: React.FC<Props> = () => (
  <ListFlowBaseDescription
    title="Sell on the #1 marketplace in sports"
    bulletItems={[
      <span key={1}>
        Our mission is to make sports more affordable, while keeping gear out of
        landfills.
      </span>,
      <span key={2}>
        Listings are promoted to our community of 1,000,000+ athletes and fans.
      </span>,
      <span key={3}>
        SidelineSwap pricing guidance helps you sell quickly while earning the
        most for your gear.
      </span>,
      <span key={4}>
        Buyers pay for shipping by default, so all you need to do is print, pack
        and ship.
      </span>,
      <span key={5}>
        Cash out your earnings to any bank, spend them on SidelineSwap, donate
        to a charity, or convert to a partner gift card.
      </span>,
    ]}
  />
);

export default ListFlowInfoDescription;
